export enum ConfirmType {
  Yes = 'Yes',
  No = 'No'
}

export enum ButtonLabels {
  Save = 'SAVE',
  Delete = 'DELETE',
  Cancel = 'CANCEL',
  Ok = 'OK',
  Close = 'CLOSE',
  Update = 'UPDATE',
  Continue = 'CONTINUE',
  Yes = 'YES',
  No = 'NO',
  Next = 'NEXT',
  Back = 'BACK'
}
